import comingSoon from "./comming_soon.png";
import delhi from "./delhi.png";
import kanpur from "./kanpur.png";
import lucknow from "./lucknow.png";
import mumbai from "./mumbai.png";
import pune from "./pune.png";
import varanasi from "./varanasi.png";

export const CITY_IMAGES = {
  delhi,
  kanpur,
  lucknow,
  mumbai,
  pune,
  varanasi,
};

export const getCityImage = (city, status) => {
  if (status !== "active") return comingSoon;

  return CITY_IMAGES[city.toLowerCase()] || comingSoon;
};
